import React, { useContext } from "react";
import styled, { ThemeContext } from "styled-components";
import { CircularProgress } from "@material-ui/core";

const SpinnerContainer = styled.div`
  margin: 30px;
  text-align: center;
`;
SpinnerContainer.displayName = "SpinnerContainer";

const StyledSpinner = () => {
  const theme = useContext(ThemeContext);
  return (
    <SpinnerContainer>
      <CircularProgress
        style={{ color: theme.colours.button.primary.background }}
      />
    </SpinnerContainer>
  );
};

export default StyledSpinner;
